import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.catalogos.cartaporte_clave_unidad_peso = {
      ...state.app.catalogos.cartaporte_clave_unidad_peso,
      filters: {
        ...state.app.catalogos.cartaporte_clave_unidad_peso.filters,
        ...meta,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.catalogos.cartaporte_clave_unidad_peso;

    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      page: meta.page || 1,
    };

    const response = await Http.get('catalogos/clave-unidad-peso', { params });

    store.setState((state) => {
      state.app.catalogos.cartaporte_clave_unidad_peso = {
        ...state.app.catalogos.cartaporte_clave_unidad_peso,
        busy: false,
        data: response.data,
        pagination: {
          ...state.app.catalogos.cartaporte_clave_unidad_peso.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.catalogos.cartaporte_clave_unidad_peso.busy = false;
      state.app.catalogos.cartaporte_clave_unidad_peso.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.catalogos.cartaporte_clave_unidad_peso = {
      ...initialState,
    };
  });
};

const CartaPorteClaveUnidadPesoSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default CartaPorteClaveUnidadPesoSuggestionsStore;
